import {configureStore} from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import authReducer, {clearAuth, clearUserData} from './authSlice';
import {onAuthInvalidated, api} from '../services/api';
import {storage} from '../services/storage';
import {clearFrameCache} from '../services/offlineCache';
import {setUser as setSentryUser} from '../services/sentry';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Auto-logout on 401 responses
onAuthInvalidated(() => {
  store.dispatch(clearAuth());
  api.clearToken();
  clearFrameCache();
  storage.removeItem('oma_cached_user');
  clearUserData();
});

// Track auth state changes for Sentry user context
let previousUser = store.getState().auth.user;
store.subscribe(() => {
  const currentUser = store.getState().auth.user;
  if (previousUser !== currentUser) {
    setSentryUser(currentUser);
    previousUser = currentUser;
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
